import React from "react";

const ToolkitIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.905 1.5H4.09497C2.66382 1.5 1.5 2.66418 1.5 4.09497V19.905C1.5 21.3358 2.66382 22.5 4.09497 22.5H19.905C21.3362 22.5 22.5 21.3358 22.5 19.905V4.09497C22.5 2.66418 21.3362 1.5 19.905 1.5ZM19.905 21H14.9927V18.4775C16.3953 17.4686 17.22 15.8734 17.22 14.1299C17.22 12.1022 16.095 10.2682 14.283 9.3446C14.0508 9.22559 13.7739 9.23657 13.5505 9.37317C13.3279 9.5094 13.1924 9.75146 13.1924 10.0126V13.3356L11.8499 14.38L10.5073 13.3356V10.0126C10.5073 9.75146 10.3718 9.5094 10.1492 9.37317C9.92651 9.23657 9.64819 9.22559 9.41675 9.3446C7.60474 10.2682 6.47974 12.1022 6.47974 14.1299C6.47974 15.8734 7.30518 17.469 8.70776 18.4775V21H4.09497C3.49146 21 3 20.5089 3 19.905V7.875H21V19.905C21 20.5089 20.5085 21 19.905 21ZM10.2078 21V18.0751C10.2078 17.8129 10.0708 17.5697 9.84668 17.4338C8.67773 16.7245 7.97974 15.4896 7.97974 14.1299C7.97974 13.1356 8.35547 12.2062 9.00732 11.5034V13.7025C9.00732 13.934 9.11426 14.1526 9.29663 14.2947L11.3892 15.9221C11.6602 16.1323 12.0396 16.1323 12.3105 15.9221L14.4031 14.2947C14.5854 14.1526 14.6924 13.934 14.6924 13.7025V11.5034C15.3442 12.2062 15.72 13.1356 15.72 14.1299C15.72 15.4893 15.022 16.7245 13.8538 17.4338C13.6296 17.5701 13.4927 17.8129 13.4927 18.0751V21H10.2078ZM3 6.375V4.09497C3 3.49109 3.49146 3 4.09497 3H19.905C20.5085 3 21 3.49109 21 4.09497V6.375H3Z"
        fill="#17142A"
      />
      <path
        d="M4.87427 3.9375H4.86694C4.45312 3.9375 4.12061 4.27332 4.12061 4.6875C4.12061 5.10168 4.46045 5.4375 4.87427 5.4375C5.28882 5.4375 5.62427 5.10168 5.62427 4.6875C5.62427 4.27332 5.28882 3.9375 4.87427 3.9375Z"
        fill="#17142A"
      />
      <path
        d="M7.48389 3.9375H7.47656C7.06274 3.9375 6.73022 4.27332 6.73022 4.6875C6.73022 5.10168 7.07007 5.4375 7.48389 5.4375C7.89844 5.4375 8.23389 5.10168 8.23389 4.6875C8.23389 4.27332 7.89844 3.9375 7.48389 3.9375Z"
        fill="#17142A"
      />
      <path
        d="M10.0928 3.9375H10.0854C9.67163 3.9375 9.33911 4.27332 9.33911 4.6875C9.33911 5.10168 9.67896 5.4375 10.0928 5.4375C10.5073 5.4375 10.8428 5.10168 10.8428 4.6875C10.8428 4.27332 10.5073 3.9375 10.0928 3.9375Z"
        fill="#17142A"
      />
    </svg>
  );
};

export default ToolkitIcon;
